export enum StatusEnum {
    None = 0,
    New = 1,
    InProgress = 2,
    Completed = 3,
    Archived = 4,
    ClosedWithNoAction = 5,
    Expired = 6,
}
